export default {
    CREATE_WORK_SPACE: "Создание пространства",
    EDIT_WORK_SPACE: "Редактирование пространства"
};
